import React from 'react';

interface SvgPreviewProps {
  svgContent: string;
}

const SvgPreview: React.FC<SvgPreviewProps> = ({ svgContent }) => {
  return (
    <div
      className="ai-svg-preview"
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};

export default SvgPreview;